import type {WhatsappAction} from 'src/action-creators/whatsapp';
import type {WhatsappState} from 'src/types/whatsapp';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {getMessagingDefaultNoteWritebackState} from 'src/utils/note-writeback';

import {
  RECEIVE_WHATSAPP_INFO,
  UPDATE_WHATSAPP_INFO,
  UPDATE_NODE_SCHEDULE,
  UPDATE_NOTE_WRITEBACK,
  RESET,
} from 'src/action-creators/whatsapp';


const initialState = {
  to_number: null,
  from_number: null,
  external_source_id: null,
  selected_template: null,
  variables: {},
  body: '',
  sender_category: null,
  ...getMessagingDefaultNoteWritebackState(),
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
} as const;

export default (
  state: WhatsappState = initialState,
  action: WhatsappAction,
): WhatsappState => {
  switch (action.type) {
    case UPDATE_WHATSAPP_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_WHATSAPP_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NOTE_WRITEBACK:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  return state;
};
